import { $http } from "@/assets/js/appFunc";

export const getComponentsList = (context) => {
    if (context.state.componentList.length === 0) {
        const firstReq = {
            type: "GET",
            url: "/gui/control/portal/detailed/list",
            data: null
        };
        $http(firstReq).then(
            data => {
                const detailedList = data.data;
                const secondReq = {
                    type: "GET",
                    url: "/gui/control/portal/revision/install/list",
                    data: null
                };
                $http(secondReq).then(
                    data => {
                        const payload = {
                            detailed: detailedList,
                            install: data.data
                        };
                        context.commit("setComponentList", payload);
                    },
                    error => console.log(error)
                );
            },
            error => console.log(error)
        );
    }
};

export const removeComponent = (context, component) => {
    const payload = {
        guiControlId: component.guiControlId,
        installedGUIControlRevisionId: component.installedGUIControlRevisionId,
        toBeInstalledGUIControlRevisionId: null
    };

    const req = {
        type: "POST",
        url: "/gui/control/portal/revision/install/schedule",
        data: payload
    };

    $http(req).then(
        data => context.commit("uninstallComponent", component),
        error => console.log(error)
    );
};

export const installComponent = (context, component) => {
    const payload = {
        guiControlId: component.guiControlId,
        installedGUIControlRevisionId: component.installedGUIControlRevisionId,
        toBeInstalledGUIControlRevisionId: component.revisions[0].guiControlRevisionId
    };

    const req = {
        type: "POST",
        url: "/gui/control/portal/revision/install/schedule",
        data: payload
    };

    $http(req).then(
        data => context.commit("installComponent", component),
        error => console.log(error)
    );
};

export const updatecomponent = (context, component) => {
    const payload = {
        guiControlId: component.guiControlId,
        installedGUIControlRevisionId: component.installedGUIControlRevisionId,
        toBeInstalledGUIControlRevisionId: component.revisions[0].guiControlRevisionId
    };

    const req = {
        type: "POST",
        url: "/gui/control/portal/revision/install/schedule",
        data: payload
    };

    $http(req).then(
        data => context.commit("updateComponent", component),
        error => console.log(error)
    );
};

export const syncComponents = (context) => {
    const req = {
        type: "PUT",
        url: "/marketplace/addons/sync",
        data: null
    };

    $http(req).then(
        data => {},
        error => console.log(error)
    );
};
